export default __webpack_public_path__ + "static/logo-footer-c3693c16b663e67104e05eb10ec61bf2.svg";